import { render } from "./ManagerContentReviews.vue?vue&type=template&id=73fa4cca"
import script from "./ManagerContentReviews.vue?vue&type=script&lang=js"
export * from "./ManagerContentReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__